import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import Avatar from 'jitsi/base/avatar/components/Avatar';
import LargeVideoManager from '../../../../../modules/UI/videolayout/LargeVideoManager';
import JitsiThemeProviderWeb from 'jitsi/base/ui/components/JitsiThemeProvider.web';

/**
 * Manager for all Large containers.
 */
export default class IISightLargeVideoManager extends LargeVideoManager {
  updateAvatar() {
    ReactDOM.render(
      <Provider store={APP.store}>
        <JitsiThemeProviderWeb>
          <Avatar id='dominantSpeakerAvatar' participantId={this.id} size={200} />
        </JitsiThemeProviderWeb>
      </Provider>,
      this._dominantSpeakerAvatarContainer,
    );
  }
}
